<rid-klank-switch
  class="h-dvh"
  [assignments]="[
    {
      prompt: {
        type: 'CONTENT',
        layout: 'HORIZONTAL',
        image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/tRbHTlab4z8VFbpW_d-7z.png',
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
      },
      answer: ['t', 'ij', 'g', 'e', 'r'],
      shuffle: shuffle(),
    },
    {
      prompt: {
        type: 'CONTENT',
        layout: 'HORIZONTAL',
        image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/BJuCpMZwjLRDH22qN_3C-.png',
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
      },
      answer: ['l', 'eeuw'],
      shuffle: shuffle(),
    },
    {
      prompt: {
        type: 'CONTENT',
        layout: 'HORIZONTAL',
        image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/EnNEt6JxcpmKOEZK0mbG9.png',
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
      },
      answer: ['z', 'e', 'b', 'r', 'a'],
      shuffle: shuffle(),
    },
  ]"
  (finished)="router.navigate(['mechanics/phonetic-comprehension'])"
/>
